import { render, staticRenderFns } from "./TipCarousel.vue?vue&type=template&id=0f3bd320&scoped=true"
import script from "./TipCarousel.vue?vue&type=script&lang=ts"
export * from "./TipCarousel.vue?vue&type=script&lang=ts"
import style0 from "./TipCarousel.vue?vue&type=style&index=0&id=0f3bd320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3bd320",
  null
  
)

export default component.exports